// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ZHgD","content":"styles_content__2VzRx","row":"styles_row__3GfWC","footer":"styles_footer__2_JyF","phraseLength":"styles_phraseLength__2XYL5"};